export const hajjiManagementTags = ['hajji-management'];
